import { isNullOrWhitespace } from '@app/components/React/Common/Utils';
import * as Yup from 'yup';


export const SampleKeyboardInputSchema = Yup.object().shape({
    kitId: Yup.number().required().label(window.translation?.common?.kit ?? "Kit").nullable().meta({ search: false }),
    name: Yup.string().label("Sample Name").required().meta({ search: false }),
    systems: Yup.array().of(
        Yup.object().shape({
            name: Yup.string().required().label(window.translation?.common?.system ?? "System"),
            allele1: Yup.string().nullable().label(window.translation?.common?.allele ?? "Allele").when('allele2', {
                is: (val: string) => isNullOrWhitespace(val),
                then: schema => schema.required(),
                otherwise: schema => schema,
            }),
            allele2: Yup.string().nullable().label(window.translation?.common?.allele ?? "Allele").when('allele1', {
                is: (val: string) => isNullOrWhitespace(val),
                then: schema => schema.required(),
                otherwise: schema => schema,
            }),
        }, [['allele1', 'allele2']]) // ensure both alleles are validated together
    ).label("Systems").min(1, "At least one system is required"),
});
